
<router-outlet></router-outlet>

<div *ngIf="isPageLoader" class="page-content-loader">
    <div class="content-loader">Loading...</div>
</div>

